"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Group: function() {
        return _ListGroup.ListGroup;
    },
    Item: function() {
        return _ListGroupItem.ListGroupItem;
    }
});
const _ListGroup = require("./ListGroup");
const _ListGroupItem = require("./ListGroupItem/ListGroupItem");

//# sourceMappingURL=index.js.map